import React from "react";

import { Props } from "@/mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaignsPage";
import { topicUrl } from "@/mk2/apps/forum/helpers";
import { ListItem, ListItemPlaceholder } from "@/mk2/components/ListItem";
import { ListItemIcon } from "@/mk2/components/ListItemIcon";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { monthAndYear } from "@/mk2/helpers/timeformat";
import { FORUM_ARCHIVED_CAMPAIGN_ACTIVE } from "@/mk/autogenerated/translation";

import styles from "./ArchivedCampaigns.mscss";

class ArchivedCampaigns extends React.Component<Props> {
    public render() {
        const { loadingState, onLoad, items } = this.props;

        return (
            <div className={styles.ArchivedCampaigns}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={onLoad}
                    onRenderInit={this.renderInit}
                    onRenderSuccess={this.renderSuccess}
                    hasData={!!items && items.length > 0}
                />
            </div>
        );
    }

    private renderInit = () => {
        return (
            <>
                <ListItemPlaceholder icon isLast={false} />
                <ListItemPlaceholder icon isLast={false} />
                <ListItemPlaceholder icon isLast={false} />
                <ListItemPlaceholder icon isLast={false} />
                <ListItemPlaceholder icon isLast />
            </>
        );
    };

    private renderSuccess = () => {
        const { items } = this.props;

        return (
            <>
                {items.map((item, index) => (
                    <ListItem
                        key={item.id}
                        icon={<ListItemIcon lazy photo={item.topic.coverPhoto} />}
                        isLast={items.length === index + 1}
                        to={topicUrl(item.topic)}
                    >
                        {item.topic.name}
                        <span className={styles.ArchivedCampaigns__date}>
                            {`(${item.isActive ? FORUM_ARCHIVED_CAMPAIGN_ACTIVE : monthAndYear(item.date)})`}
                        </span>
                    </ListItem>
                ))}
            </>
        );
    };
}

export default ArchivedCampaigns;
